import { render, staticRenderFns } from "./WaterAnalysis.vue?vue&type=template&id=1746e1c0&scoped=true"
import script from "./WaterAnalysis.vue?vue&type=script&lang=js"
export * from "./WaterAnalysis.vue?vue&type=script&lang=js"
import style0 from "./WaterAnalysis.vue?vue&type=style&index=0&id=1746e1c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1746e1c0",
  null
  
)

export default component.exports